import { Dispatch } from "react";
import ConversationRecord from "models/view-models/conversations/conversation-record";
import ConversationService from "utilities/services/conversations/conversation-service";
import { ConversationHistoryAction } from "./conversation-history-atom-reducer";

/**
 * Renames a conversation.
 * This thunk will update the title of an existing conversation and update the state accordingly.
 */
export const renameConversation =
    (conversation: Pick<ConversationRecord, "id" | "title">) =>
    async (dispatch: Dispatch<ConversationHistoryAction>) => {
        if (!conversation.id || !conversation.title) {
            dispatch({
                type: "ERROR",
                error: new Error("Conversation ID and title are required."),
            });
            return;
        }

        // Immediately dispatch the rename action to update the UI optimistically
        dispatch({
            type: "RENAME_CONVERSATION",
            id: conversation.id,
            title: conversation.title,
        });

        const errorMessage =
            "Something went wrong, your changes were not saved.";

        try {
            await ConversationService.rename(
                { id: conversation.id },
                { title: conversation.title }
            );
            return;
        } catch (error) {
            dispatch({
                type: "ERROR",
                error: new Error(errorMessage),
            });
        }

        dispatch({
            type: "ERROR",
            error: new Error(errorMessage),
        });
    };
